module.exports = __webpack_public_path__ + "fonts/Ubuntu-Italic.fe21cff.eot";